import React, { useEffect, useState } from 'react';
import { Tree } from 'antd';
import type { TreeDataNode, TreeProps } from 'antd';
import { IAsset } from '../../models/Assets';

type Props = {
    assetsPMV: IAsset[];
    assetId: number;
    checkedKeys: TreeProps['checkedKeys'];
    setCheckedKeys: (checkedKeys: TreeProps['checkedKeys']) => void;
}

const TreePMV: React.FC<Props> = ({ assetsPMV, assetId, checkedKeys, setCheckedKeys }: Props) => {
    const [treeData, setTreeData] = useState<TreeDataNode[]>([]);

    useEffect(() => {
        setTreeData(assetsPMV.map(asset => {
            return {
                title: asset.description,
                key: asset.id
            }
        }));
    }, [assetsPMV]);

    const onSelect: TreeProps['onSelect'] = (selectedKeys, info) => {
        console.log('selected', selectedKeys, info);
    };

    const onCheck: TreeProps['onCheck'] = (checkedKeys, info) => {
        console.log('onCheck', checkedKeys, info);
        setCheckedKeys(checkedKeys);
    };


    return (
        <Tree
            checkable
            defaultExpandedKeys={[]}
            defaultSelectedKeys={[]}
            defaultCheckedKeys={[assetId]}
            onSelect={onSelect}
            onCheck={onCheck}
            checkedKeys={checkedKeys}
            treeData={treeData}
        />
    );
};

export default TreePMV;